import { ConversationParticipantRole } from 'models/conversations'

import { Auth0Roles } from 'models/auth/auth0'
import { PlatformRole } from 'models/user'

/**
 * Maps a platform-side role to the corresponding `ConversationParticipantRole`. Used to find the
 * caller's entry in a conversation's `participants[]` so we can resolve their platform UUID for
 * outgoing-message detection.
 *
 * `platformRole` from `/user/me` is preferred over the Auth0 role because BKBN dev auto-promotes
 * every `@bkbn.com` signup to ADMIN on Auth0 — but the underlying platform user might be a
 * CLIENT or CREATIVE, and that's what gets stored on conversation participants.
 */
export const resolveExpectedParticipantRole = (
  platformRole: PlatformRole | undefined,
  authRoles: Auth0Roles
): ConversationParticipantRole | undefined => {
  if (platformRole === PlatformRole.CLIENT) return ConversationParticipantRole.CLIENT
  if (platformRole === PlatformRole.CREATIVE) return ConversationParticipantRole.CREATIVE
  if (platformRole === PlatformRole.AGENT) return ConversationParticipantRole.AGENT

  if (authRoles.isClient) return ConversationParticipantRole.CLIENT
  if (authRoles.isCreative) return ConversationParticipantRole.CREATIVE
  if (authRoles.isAdmin) return ConversationParticipantRole.AGENT
  return undefined
}
